import { useTheme } from "styled-components";

import FnrTypography from "FnrTypography";

import FnrButton from "UI/FnrButton3/FnrButton";
import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap";

import { useFnrPencilEditInputContext } from "../FnrPencilEditInput";

const SaveButton = () => {
  const { isSaving, onSave, labelSuffix } = useFnrPencilEditInputContext();
  const {
    palette: { fnBlue },
  } = useTheme();

  return (
    <FnrHorizontalGap reverse>
      <FnrButton
        color={fnBlue}
        size="small"
        aria-label={`save-${labelSuffix}`}
        onClick={onSave}
        loading={isSaving}
        preventDefault
      >
        <FnrTypography color="textLight" type="accent" bold={false}>
          Save
        </FnrTypography>
      </FnrButton>
    </FnrHorizontalGap>
  );
};

export default SaveButton;
